/** Cloudflare Turnstile — client configuration and action names */

export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''

export const TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

export const TURNSTILE_ACTIONS = {
  HUB_LOGIN: 'hub_login',
  INTAKE_FORM: 'intake_form',
  CONTACT_FORM: 'contact_form',
}

export const TURNSTILE_MESSAGES = {
  REQUIRED: 'Please complete the security verification.',
  NOT_CONFIGURED: 'Security verification is not configured. Contact your administrator.',
  VERIFY_FAILED: 'Security verification failed. Please try again.',
  UNAVAILABLE: 'Security verification unavailable. Please try again later.',
}

/** Request body field sent to API routes that require Turnstile */
export const TURNSTILE_TOKEN_FIELD = 'turnstileToken'

export function isTurnstileEnabled () {
  return Boolean(TURNSTILE_SITE_KEY)
}

/** Turnstile render target (scoped under .hub-login-turnstile-host on login) */
export const TURNSTILE_WRAPPER_CLASS =
  'viva-turnstile flex w-full items-center justify-center'
